import {Card, Col, Row} from "react-bootstrap";
import {NewsArticleDTO} from "./NewsArticleDTO";
import React from "react";
import "./news.css";

type Props = {
    article: NewsArticleDTO,
    fire?: boolean
};

export const NewsArticleComponent = (props: Props) => {
    return (
        <Row className="justify-content-center mb-5">
            <Col xs={12} md={10} lg={8}>
                <Card className="news-article-card border-0">
                    <Card.Header className="news-card-header bg-white">
                        <div className="d-flex align-items-center">
                            {props.fire && (
                                <span className="fire-icon">
                                    <picture>
                                        <source srcSet="https://fonts.gstatic.com/s/e/notoemoji/latest/1f525/512.webp"
                                                type="image/webp"/>
                                        <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f525/512.gif" alt="🔥" width="32"
                                             height="32"/>
                                    </picture>
                                </span>
                            )}
                            <span className="fs-4 me-2">📌</span>
                            <h3 className="news-card-title">
                                {props.article.title}
                            </h3>
                        </div>
                    </Card.Header>
                    <Card.Body className="news-card-body">
                        {props.article.content}
                    </Card.Body>
                    <Card.Footer className="news-card-footer">
                        <div className="news-meta-item">
                            <span>🗓️</span>
                            {new Date(props.article.postDate).toLocaleDateString()}
                        </div>
                        <div className="vr mx-1"></div>
                        <div className="news-meta-item">
                            <span>🕑</span>
                            {new Date(props.article.postDate).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
                        </div>
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    )
}